let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8GEyD")).then(() => parcelRequire('d8z8o'));